import { clevertapEvent } from "utils/clevertap";

export const trackAutoBuyOrderView = () => {
  clevertapEvent("Auto Buy Buy Order Viewed");
};

export const trackAutoBuyPreviewOrderView = () => {
  clevertapEvent("Auto Buy Buy Order Previewed");
};

export const trackAutoBuyOrderReceivedView = () => {
  clevertapEvent("Auto Buy Buy Order Received Viewed");
};

export const trackAutoBuyDetailView = () => {
  clevertapEvent("Auto Buy Order Detail Viewed");
};

export const trackAutoBuyAction = (eventObject) => {
  clevertapEvent("Auto Buy Action", eventObject);
};

export const trackAutoBuyOrderTypeSelected = (buyOrderType, stock) => {
  trackAutoBuyAction({
    Action: "Auto Buy Set Order Type Selected",
    "Buy Order Type": buyOrderType,
    Stock: stock,
  });
};

export const trackAutoBuyTriggerPriceInfoSelected = () => {
  trackAutoBuyAction({
    Action: "Auto Buy Trigger Price Info Selected",
  });
};

/**
 *
 * @param {('≥' | '≤')} condition
 * @returns
 */
export const trackAutoBuyTriggerConditionSelected = (condition) => {
  trackAutoBuyAction({
    Action: "Auto Buy Trigger Condition Selected",
    Condition: condition,
  });
};

export const trackAutoBuyOrderTypeInfoSelected = (buyOrderType, stock) => {
  trackAutoBuyAction({
    Action: "Auto Buy Order Type Info Selected",
    "Buy Order Type": buyOrderType,
    Stock: stock,
  });
};

export const trackAutoBuyTncSelected = () => {
  trackAutoBuyAction({
    Action: "Auto Buy Smart Order Terms & Conditions Selected",
  });
};

export const trackAutoBuyOrderCanceled = () => {
  trackAutoBuyAction({ Action: "Auto Buy Order Buy Canceled" });
};

export const trackAutoBuyOrderPlaced = () => {
  trackAutoBuyAction({ Action: "Auto Buy Buy Order Placed" });
};

export const trackAutoBuyConfirmOrderCanceled = (
  stock,
  buyOrderType,
  expiry,
  triggerPrice,
  buyPrice,
  lot,
) => {
  trackAutoBuyAction({
    Action: "Auto Buy Buy Order Canceled",
    Stock: stock,
    "Buy Order Type": buyOrderType,
    Expiry: expiry,
    "Trigger Price": triggerPrice,
    "Buy Price": buyPrice,
    Lot: lot,
  });
};

export const trackAutoBuyOrderConfirmed = (
  stock,
  buyOrderType,
  expiry,
  triggerPrice,
  buyPrice,
  lot,
) => {
  trackAutoBuyAction({
    Action: "Auto Buy Buy Order Confirmed",
    Stock: stock,
    "Buy Order Type": buyOrderType,
    Expiry: expiry,
    "Trigger Price": triggerPrice,
    "Buy Price": buyPrice,
    Lot: lot,
  });
};

export const trackAutoBuyOrderDone = () => {
  trackAutoBuyAction({ Action: "Auto Buy Buy Order Done" });
};

export const trackAutoBuyCancelOrderSelected = (
  stock,
  buyOrderType,
  expiry,
  triggerPrice,
  buyPrice,
  lot,
) => {
  trackAutoBuyAction({
    Action: "Auto Buy Cancel Order Selected",
    Stock: stock,
    "Buy Order Type": buyOrderType,
    Expiry: expiry,
    "Trigger Price": triggerPrice,
    "Buy Price": buyPrice,
    Lot: lot,
  });
};

export const trackAutoBuyAmendSelected = (
  stock,
  buyOrderType,
  expiry,
  triggerPrice,
  buyPrice,
  lot,
) => {
  trackAutoBuyAction({
    Action: "Auto Buy Amend Selected",
    Stock: stock,
    "Buy Order Type": buyOrderType,
    Expiry: expiry,
    "Trigger Price": triggerPrice,
    "Buy Price": buyPrice,
    Lot: lot,
  });
};

// #endregion Auto Buy

// #region Auto Sell
export const trackAutoSellAutoOrderView = () => {
  clevertapEvent("Auto Sell Auto Order Viewed");
};

/**
 *
 * @param {("Stop Loss"|"Take Profit")} type
 */
export const trackAutoSellFormView = (type) => {
  clevertapEvent(`Auto Sell ${type} Viewed`);
};

/**
 *
 * @param {("Stop Loss"|"Take Profit")} type
 */
export const trackAutoSellInfoView = (type) => {
  clevertapEvent(`Auto Sell ${type} Information Viewed`);
};

export const trackAutoSellDetailOrderView = () => {
  clevertapEvent("Auto Sell Detail Auto Order Viewed");
};

/**
 *
 * @param {("Edit"|"Delete")} type
 */
export const trackAutoSellAlterOrderView = (type) => {
  clevertapEvent(`Auto Sell ${type} Auto Order Viewed`);
};

const trackAutoSellAction = (eventObject) => {
  clevertapEvent("Auto Sell Action", eventObject);
};

/**
 *
 * @param {string} stock
 */
export const trackAutoSellOrderSelected = (stock) => {
  trackAutoSellAction({
    Action: "Auto Sell Set Auto Order Selected",
    Stock: stock,
  });
};

/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 * @param {string} stock
 */
export const trackAutoSellOrderTypeSelected = (type, stock) => {
  trackAutoSellAction({
    Action: "Auto Sell Auto Order Type Selected",
    "Auto Sell Type": type,
    Stock: stock,
  });
};

export const trackAutoOrderCanceled = () => {
  trackAutoSellAction({ Action: "Auto Sell Auto Order Canceled" });
};

/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 */
export const trackAutoSellInfoSelected = (type) => {
  trackAutoSellAction({ Action: `Auto Sell ${type} Information Selected` });
};

export const trackAutoSellOrderQuantityAdjusted = () => {
  trackAutoSellAction({ Action: "Auto Sell Sell Order Quantity Adjusted" });
};

/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 * @param {string} stock
 * @param {number} lot
 * @param {number} price
 * @param {string} tpPercentage
 * @param {string} slPercentage
 */
export const trackAutoSellOrderConfirmed = (
  type,
  stock,
  lot,
  price,
  gainPercentage,
) => {
  trackAutoSellAction({
    Action: "Auto Sell Sell Order Confirmed",
    "Auto Sell Type": type,
    Stock: stock,
    Lot: lot,
    Price: price,
    "Take Profit Percentage": type === "Take Profit" ? gainPercentage : 0,
    "Stop Loss Percentage": type === "Stop Loss" ? gainPercentage : 0,
  });
};

export const trackAutoSellOrderCanceled = () => {
  trackAutoSellAction({ Action: "Auto Sell Sell Order Canceled" });
};

export const trackAutoSellOrderInfoClosed = () => {
  trackAutoSellAction({ Action: "Auto Sell Auto Order Information Closed" });
};

export const trackAutoSellOrderDetailClosed = () => {
  trackAutoSellAction({ Action: "Auto Sell Auto Order Detail Closed" });
};

/**
 *
 * @param {("Add"|"Edit"|"Delete")} type
 */
export const trackAutoSellAlterOrderSelected = (type) => {
  trackAutoSellAction({ Action: `Auto Sell ${type} Auto Order Selected` });
};

export const trackAutoSellDeleteCanceled = () => {
  trackAutoSellAction({ Action: "Auto Sell Delete Canceled" });
};

export const trackAutoSellOrderDeleted = () => {
  trackAutoSellAction({ Action: "Auto Sell Auto Order Deleted" });
};

export const trackAutoSellOrderTncSelected = () => {
  trackAutoSellAction({
    Action: "Auto Sell Auto Order Terms & Conditions Selected",
  });
};

// #endregion Auto Sell
